export const PROMO_CODE_STATUSES = {
  APPLIED: 'PROMOTION_APPLIED',
  NOT_APPLIED: 'PROMOTION_NOT_APPLIED',
  INVALID: 'PROMOTION_INVALID',
  EXPIRED: 'PROMOTION_EXPIRED',
};

export const PRIVACY_PERMISSIONS = {
  UGP_BEHAVIORAL_ADS: `adtargeting_behavioralevents`,
  UGP_PERFORMANCE_ANALYTICS: `performance`,
  UGP_1ST_PARTY_AUDIENCE: `adtargeting_hashedmatch`,
  UGP_PERSONALIZATION: `personalization_targeted_comms`,
};

export const PIXLEE_KEY = 'GCJQ804EuO6jQdTgdYKX';
export const PIXLEE_SCRIPT_ID = 'pixlee_script';
export const PIXLEE_SCRIPT_SRC = 'https://assets.pixlee.com/assets/pixlee_events.js';
